import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        country: String,
        eventLabel: String,
        holiday: Object,
        // DDT-4157: opens on load, for a freemium lawyer sent here from a paid-only page.
        shouldOpen: Boolean,
    };

    static targets = [
        'dateSlotPicker',
        'dateDropdownOptions',
        'timeDropdownOptions',
        'timePickerRadioButtons',
        'invalidWorkingTimeOption',
        'dateSlotPickerOption',
        'modalContainer',
    ];

    contactType = 'fixedTime';
    isTodayAvailableBasedOnWorkingHourAndHourNow = true;
    timeZone = 'UTC';

    connect() {
        this.modal = new Modal(this.element, {
            backdrop: 'static',
            focus: false,
            show: false,
        });

        this.eventLabel = null;

        if (this.shouldOpenValue) {
            this.modal.show();
            this.eventLabel = this.eventLabelValue || null;
        }

        if ('gb' === this.countryValue) {
            this.timeZone = 'Europe/London';
        } else if ('fr' === this.countryValue) {
            this.timeZone = 'Europe/Paris';
        } else if ('be' === this.countryValue) {
            this.timeZone = 'Europe/Brussels';
        }

        this.checkWorkingHours();
        setTimeout(() => {
            this.hideTimeSlotsForCurrentDates();
            this.changeTimeDropdownPlaceholder();
        }, 500);

        this.dateDropdownOptionsTarget.addEventListener('change', () => {
            this.onDateChangeReloadHourOptions();
            this.hideTimeSlotsForCurrentDates();
            this.changeTimeDropdownPlaceholder();
        });

        // Periodically check for time slot controls
        const intervalForTimeSlotSetup = setInterval(() => {
            if (document.querySelector('#time-slot-section .ts-control')) {
                document.querySelector('#time-slot-section .ts-control').addEventListener('click', () => {
                    this.hidePastTimeSlots();
                    this.hideTimeSlotsForCurrentDates();
                });

                clearInterval(intervalForTimeSlotSetup);
            }
        }, 500);
    }

    openModal(event) {
        this.modal.show();
        this.eventLabel = event.currentTarget.dataset.eventLabel || null;
    }

    selectTimeOption(event) {
        this.contactType = event.target.value;

        if (this.contactType === 'fixedTime') {
            $(this.dateSlotPickerTarget).addClass('d-none');
        } else if (this.contactType === 'dateSlotPicker') {
            $(this.dateSlotPickerTarget).removeClass('d-none');
            this.hideTimeSlotsForCurrentDates();
            this.changeTimeDropdownPlaceholder();
        }
    }

    sendContactRequest() {
        showPreloader();
        let selectedTime, selectedEndTime, startDate;

        if (this.contactType === 'fixedTime') {
            const now = new Date();

            selectedTime = now.getHours().toString().padStart(2, '0') +
                ':' + now.getMinutes().toString().padStart(2, '0') +
                ':' + now.getSeconds().toString().padStart(2, '0') + this.getStandardTimeZone();

            const futureTime = new Date(now.getTime() + 30 * 60000);
            selectedEndTime = futureTime.getHours().toString().padStart(2, '0') +
                ':' + futureTime.getMinutes().toString().padStart(2, '0') +
                ':' + futureTime.getSeconds().toString().padStart(2, '0') + this.getStandardTimeZone();

            startDate = now.toISOString().split('T')[0];
        } else {
            startDate = this.dateDropdownOptionsTarget.selectedOptions[0].dataset.date;
            selectedTime = this.timeDropdownOptionsTarget.selectedOptions[0].dataset.time;
            selectedEndTime = this.timeDropdownOptionsTarget.selectedOptions[0].dataset.endTime;
        }

        const startDateBooking = startDate + 'T' + selectedTime;
        const endDateBooking = startDate + 'T' + selectedEndTime;

        const dataToSend = {
            contactType: this.contactType,
            dateSlot: this.dateDropdownOptionsTarget.value,
            timeSlot: this.dateSlotPickerOptionTarget.checked ? this.timeDropdownOptionsTarget.value : '',
            startDateBooking: startDateBooking,
            endDateBooking: endDateBooking,
            eventLabel: this.eventLabel,
        };

        $.ajax({
            type: 'POST',
            url: routes['app_default_freemiumcontactsales'],
            data: dataToSend,
            success: (response) => {
                if (response.status) {
                    addAlert('success', response.message);
                } else {
                    addAlert('danger', response.message);
                }

                $(this.modalContainerTarget).modal('hide');
                hidePreloader();
                window.location.reload();
            },
            error: function(error) {
                hidePreloader();
                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }

    holidayDayState(dateKey) {
        const settings = this.hasHolidayValue ? this.holidayValue : {};
        const exceptions = settings.exceptions || {};
        const periods = settings.periods || [];

        if (Object.prototype.hasOwnProperty.call(exceptions, dateKey)) {
            const openSlots = exceptions[dateKey] || [];

            return openSlots.length > 0 ? { openSlots } : 'off';
        }

        const isInPeriod = periods.some(
            (period) => period.start && period.end && dateKey >= period.start && dateKey <= period.end,
        );

        return isInPeriod ? 'off' : null;
    }

    checkWorkingHours() {
        const validWorkingTimeContainer = this.timePickerRadioButtonsTarget;
        const invalidWorkingTimeContainer = this.invalidWorkingTimeOptionTarget;
        const dateOptions = this.dateSlotPickerTarget;

        if (!validWorkingTimeContainer || !invalidWorkingTimeContainer) {
            return;
        }

        const localDate = this.getLocalTime(this.timeZone);
        const currentDateString = localDate.toISOString().split('T')[0];

        if (this.holidayDayState(currentDateString) === 'off') {
            validWorkingTimeContainer.classList.add('d-none');
            invalidWorkingTimeContainer.classList.remove('d-none');
            dateOptions.classList.remove('d-none');
            this.dateSlotPickerOptionTarget.checked = true;
            this.contactType = 'dateSlotPicker';
            return;
        }

        const localHour = localDate.getHours();

        const localMinute = localDate.getMinutes();
        const localDay = localDate.getDay();

        const startHourInLocalTime = 9;
        const endHourInLocalTime = 17;
        const isInWeekendDays = (localDay === 0 || localDay === 6);
        const isInWorkingHours =
            (localHour > startHourInLocalTime || (localHour === startHourInLocalTime && localMinute >= 15)) &&
            (localHour < endHourInLocalTime || (localHour === endHourInLocalTime && localMinute <= 30));

        const lunchBreakStart = 12;
        const lunchBreakEnd = 14;

        const isLunchBreak =
            (localHour > lunchBreakStart || (localHour === lunchBreakStart && localMinute >= 30)) &&
            localHour < lunchBreakEnd;

        // We check if the current day is a weekend day or if the current time is outside the working hours
        if (isInWeekendDays || !isInWorkingHours || isLunchBreak) {
            validWorkingTimeContainer.classList.add('d-none');
            invalidWorkingTimeContainer.classList.remove('d-none');
            dateOptions.classList.remove('d-none');
            this.dateSlotPickerOptionTarget.checked = true;
            this.contactType = 'dateSlotPicker';
        }
    }

    getLocalTime(timeZone) {
        const localTime = new Date().toLocaleString('en-US', { timeZone: timeZone });

        return new Date(localTime);
    }

    getStandardTimeZone() {
        const timezoneNumber = Math.abs(new Date().getTimezoneOffset() / 60);
        let timezone = null;

        if (timezoneNumber < 10) {
            timezone = '+0' + timezoneNumber + '00';
        } else {
            timezone = '+' + timezoneNumber + '00';
        }

        return timezone; // e.g., "+0200"
    }

    hidePastTimeSlots() {
        let selectedDateObj = this.convertSelectedDateIntoObjectDate();

        if (selectedDateObj !== new Date().getDate()) {
            return;
        }

        setTimeout(() => {
            const timeslots = document.querySelectorAll('#time-slot-section #timeDropdownOptions-ts-dropdown .option');
            const bufferTime = 10;
            const currentTime = this.getLocalTime(this.timeZone);
            const currentTimeInMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();

            timeslots.forEach(slot => {
                const timeString = slot.dataset.value;
                let optionHour = null;
                let optionMinute = null;

                if ('gb' === this.countryValue) {
                    optionHour = parseInt(timeString.slice(0, 2), 10);
                    optionHour = optionHour < 9 ? optionHour + 12 : optionHour;
                    optionMinute = parseInt(timeString.slice(3, 5), 10);
                } else {
                    optionHour = parseInt(timeString.split('h')[0]);
                    optionMinute = parseInt(timeString.split('h')[1]);
                }

                let optionTimeInMinutes = optionHour * 60 + optionMinute;
                if (optionTimeInMinutes <= currentTimeInMinutes + bufferTime) {
                    slot.classList.add('d-none');
                }
            });
        }, 1);
    }

    changeTimeDropdownPlaceholder() {
        if (false === this.isTodayAvailableBasedOnWorkingHourAndHourNow) {
            return;
        }

        let selectedDateObj = this.convertSelectedDateIntoObjectDate();
        let firstAvailableSlot = null;
        const selectedDate = document.getElementById('selectDatepickerOption').selectedOptions[0].dataset.date;


        if (selectedDateObj !== new Date().getDate()) {
            // Sort by data-time first: TomSelect reorders the <option> DOM as
            // values are selected, so picking by DOM order made the default slot
            // drift forward on each revisit of a partially open day.
            const timeslots = $(this.timeDropdownOptionsTarget).find('option').toArray();
            const dayState = this.holidayDayState(selectedDate);

            timeslots.sort((a, b) => {
                const timeA = a.getAttribute('data-time');
                const timeB = b.getAttribute('data-time');

                return (null !== timeA && null !== timeB) ? timeA.localeCompare(timeB) : 0;
            });

            timeslots.forEach(slot => {
                slot.removeAttribute('selected');

                const isCandidate = (dayState && dayState !== 'off')
                    ? dayState.openSlots.includes(slot.value)
                    : ('09h30' === slot.value || '09:30AM' === slot.value);

                if (isCandidate && null === firstAvailableSlot) {
                    firstAvailableSlot = slot;
                    slot.setAttribute('selected', 'selected');
                }
            });
        } else {
            const timeslots = $(this.timeDropdownOptionsTarget).find('option').toArray();
            const bufferTime = 10;
            const date = this.getLocalTime(this.timeZone);
            const currentTimeInMinutes = date.getHours() * 60 + date.getMinutes();

            timeslots.sort((a, b) => {
                if (a.getAttribute('data-time') !== null && b.getAttribute('data-time') !== null) {
                    const timeA = a.getAttribute('data-time');
                    const timeB = b.getAttribute('data-time');
                    return timeA.localeCompare(timeB);
                }
            });

            timeslots.forEach((slot) => {
                slot.removeAttribute('selected');

                const timeString = slot.value;
                let optionHour = null;
                let optionMinute = null;

                if ('gb' === this.countryValue) {
                    optionHour = parseInt(timeString.slice(0, 2), 10);
                    optionHour = optionHour < 9 ? optionHour + 12 : optionHour;
                    optionMinute = parseInt(timeString.slice(3, 5), 10);
                } else {
                    optionHour = parseInt(timeString.split('h')[0]);
                    optionMinute = parseInt(timeString.split('h')[1]);
                }

                let optionTimeInMinutes = optionHour * 60 + optionMinute;

                if (optionTimeInMinutes >= currentTimeInMinutes + bufferTime && null == firstAvailableSlot) {
                    firstAvailableSlot = slot;

                    slot.setAttribute('selected', 'selected');
                }
            });
        }
        const placeholder = document.querySelector('#time-slot-section .ts-control .item');
        if (placeholder && firstAvailableSlot) {
            placeholder.textContent = firstAvailableSlot.value;
            placeholder.setAttribute('data-value', firstAvailableSlot.value);
        }

        if (firstAvailableSlot) {
            // Set the native <select> value directly (like the WP lead page).
            // Calling TomSelect.setValue() here reorders the <option> DOM and
            // re-renders async, which drifted the default slot on revisits.
            this.timeDropdownOptionsTarget.value = firstAvailableSlot.value;
        }
    }

    onDateChangeReloadHourOptions() {
        if (false === this.isTodayAvailableBasedOnWorkingHourAndHourNow) {
            return;
        }

        let selectedDateObj = this.convertSelectedDateIntoObjectDate();

        if (selectedDateObj !== new Date().getDate()) {
            document.querySelectorAll('#time-slot-section #timeDropdownOptions-ts-dropdown .option').forEach(slot => {
                slot.classList.remove('d-none');
            });
        }
    }

    convertSelectedDateIntoObjectDate() {
        const availableDates = $(this.dateDropdownOptionsTarget).find('option');
        let selectedDate = this.dateDropdownOptionsTarget.value;

        availableDates.each((date) => {
            const dateValue = availableDates[date];

            if (dateValue.value === selectedDate) {
                selectedDate = dateValue.getAttribute('data-date');
            }
        });
        return new Date(selectedDate).getDate();
    }

    hideTimeSlotsForCurrentDates() {
        const selectedDate = document.getElementById('selectDatepickerOption').selectedOptions[0].dataset.date;
        setTimeout(() => {
            const dayState = this.holidayDayState(selectedDate);

            // Only partial days filter here (full-off already off the picker).
            if (!dayState || dayState === 'off') {
                return;
            }

            const timeslots = document.querySelectorAll('#timeDropdownOptions-ts-dropdown .option');

            timeslots.forEach(slot => {
                // Hide any slot not in the day's open list.
                if (!dayState.openSlots.includes(slot.dataset.value)) {
                    slot.classList.add('d-none');
                }
            });
        }, 1);
    }
}
